import React from 'react';
import { Button } from './Button';

/**
 * ConfirmDialog - Modal confirmation dialog for destructive actions
 */
export const ConfirmDialog = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  variant = 'danger', // 'danger' | 'warning' | 'info'
}) => {
  if (!isOpen) return null;

  const variantColors = {
    danger: {
      accent: '#ff4444',
      bg: 'rgba(255,68,68,0.15)',
      border: 'rgba(255,68,68,0.4)',
    },
    warning: {
      accent: '#ffaa00',
      bg: 'rgba(255,170,0,0.15)',
      border: 'rgba(255,170,0,0.4)',
    },
    info: {
      accent: '#00c8ff',
      bg: 'rgba(0,200,255,0.15)',
      border: 'rgba(0,200,255,0.4)',
    },
  };

  const colors = variantColors[variant] || variantColors.danger;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onCancel}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.7)',
          zIndex: 2000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* Dialog */}
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            background: 'linear-gradient(180deg, rgba(20,28,36,0.99) 0%, rgba(12,18,24,0.99) 100%)',
            border: `1px solid ${colors.border}`,
            borderRadius: '12px',
            padding: '20px',
            maxWidth: '340px',
            width: '90%',
            boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
          }}
        >
          {/* Icon */}
          <div style={{
            textAlign: 'center',
            marginBottom: '12px',
          }}>
            <span style={{
              fontSize: '32px',
              display: 'inline-block',
            }}>
              {variant === 'danger' ? '⚠️' : variant === 'warning' ? '⚡' : 'ℹ️'}
            </span>
          </div>

          {/* Title */}
          <h3 style={{
            color: colors.accent,
            fontSize: '16px',
            fontWeight: '600',
            textAlign: 'center',
            margin: '0 0 8px 0',
          }}>
            {title}
          </h3>

          {/* Message */}
          <p style={{
            color: '#a0b0c0',
            fontSize: '13px',
            textAlign: 'center',
            margin: '0 0 20px 0',
            lineHeight: '1.5',
          }}>
            {message}
          </p>

          {/* Buttons */}
          <div style={{
            display: 'flex',
            gap: '10px',
            justifyContent: 'center',
          }}>
            <Button
              variant="default"
              onClick={onCancel}
              style={{ flex: 1, maxWidth: '120px' }}
            >
              {cancelText}
            </Button>
            <Button
              variant={variant === 'danger' ? 'danger' : 'primary'}
              onClick={onConfirm}
              style={{ flex: 1, maxWidth: '120px' }}
            >
              {confirmText}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmDialog;
